import { AlignmentType } from "../Models/PageCreatorPage";

const handleSectionAlignment = (
  hasImage: boolean,
  alignmentType: AlignmentType,
) => {
  if (hasImage) {
    return "justify-between";
  }

  if (alignmentType === AlignmentType.Left) {
    return "justify-start";
  }

  return "justify-center";
};

export default handleSectionAlignment;
